var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"homeArea"},[_c('h2',[_vm._v("新着情報")]),_c('div',{staticClass:"customTable"},_vm._l((_vm.newOrderInfoLocal),function(item,index){return _c('div',{key:index,staticClass:"customRow"},[_c('div',{staticClass:"customColumn"},[_vm._v(_vm._s(item.time))]),_c('div',{staticClass:"customColumn"},[_vm._v(_vm._s(item.sentence))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }